'use client';

import {
    Button,
    Calendar,
    cn,
    FormControl,
    FormField,
    FormItem,
    FormMessage,
    Label,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@repo/shadcn';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

type CalendarInputProps = {
    label?: string;
    placeholder?: string;
    fieldName: string;
    disabledNextDays?: boolean;
};

export const CalendarInput: FC<CalendarInputProps> = ({
    label,
    placeholder,
    fieldName,
    disabledNextDays = false,
}) => {
    const { control } = useFormContext();

    const renderLabel = () => {
        if (!label) {
            return null;
        }
        return (
            <Label htmlFor="date" className="px-1">
                {label}
            </Label>
        );
    };
    return (
        <div className="flex flex-col gap-3">
            <FormField
                control={control}
                name={fieldName}
                render={({ field }) => (
                    <FormItem className="flex flex-col">
                        {renderLabel()}
                        <Popover>
                            <PopoverTrigger asChild>
                                <FormControl>
                                    <Button
                                        variant={'outline'}
                                        className={cn(
                                            'w-fit gap-4 pl-3 text-left font-normal',
                                            !field.value &&
                                                'text-muted-foreground',
                                        )}
                                    >
                                        {field.value ? (
                                            format(field.value, 'PPP')
                                        ) : (
                                            <span>
                                                {placeholder || 'Pick a date'}
                                            </span>
                                        )}
                                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                    </Button>
                                </FormControl>
                            </PopoverTrigger>
                            <PopoverContent
                                className="w-auto p-0"
                                align="start"
                            >
                                <Calendar
                                    mode="single"
                                    selected={field.value}
                                    onSelect={field.onChange}
                                    disabled={
                                        disabledNextDays
                                            ? (date) =>
                                                  date > new Date() ||
                                                  date < new Date('1900-01-01')
                                            : undefined
                                    }
                                    captionLayout="dropdown"
                                />
                            </PopoverContent>
                        </Popover>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
};
